export default __webpack_public_path__ + "static/media/Control_1_Thermocycler.3a0e97c1.svg";